import { createAPI } from '../../common'
// MediaCloudPaperFull
export default {
  // 查询条件稿件状态条件项
  getOptions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0rvfsz0tubuvt0pqujpot', 'get', config),
  // 签发日期查询条件项
  getDatesOptions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0rvfsz0ebuft0pqujpot', 'get', config),
  // 加锁
  putActionsLock: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0mpdl', 'put', config),
  // 解锁
  putActionsUnlock: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0vompdl', 'put', config),
  // 签发
  putActionsSign: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0mbzpvu0tjho', 'put', config, {
      timeout: 60000
    }),
  // 获取版面
  getColumnsLayouts: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0dpmvnot0mbzpvut', 'get', config),
  // 剩稿回退列表
  putRemainingList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0bsujdmft0sfnbjojoh0mjtu',
      'get',
      config
    ),
  // 撤签
  putLayoutUnsign: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0mbzpvu0votjho', 'put', config),
  // 调版获取报纸接口
  getTunePapers: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0uvof0qbqfst', 'get', config),
  // 调版获取栏目
  getTuneColunms: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0uvof0dpmvont', 'get', config),
  // 调版获取版次
  getTuneLayouts: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0uvof0mbzpvut', 'get', config),
  // 调版
  postTune: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0uvof', 'post', config),
  // 获取版面下的稿件列表
  getPageArticles: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bsujdmft', 'get', config),
  // 获取大样版面图的真实地址
  getPageImage: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0jnbhf', 'get', config),
  // 下载版面图
  getPageDownloadimage: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0epxompbejnbhf', 'get', config),
  // 大样追踪
  getFullver: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0gvmmwfs', 'get', config),
  // 版面信息导出
  putExport: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0fyqpsu', 'PUT', config),
  // 版面信息导出
  getPdf: (config) => createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0qeg', 'get', config),

  // 上传审校文档(通过文件路径)
  UploadProofReviewFile: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0qsppg0gjmf0vqmpbe3', 'post', config, vConfig),
  // 获取审校文档的压缩包 用于UploadProofReviewFile接口参数
  getProofFileZip: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0gjmft0{jq', 'get', config, vConfig),

  // 开启文件校对任务
  startProofReviewFile: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0qsppg0w30gjmf', 'POST', config, vConfig),
  // 获取任务进度
  getProofReviewProgress: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0qsppg0qsphsftt', 'get', config, vConfig),

  // 获取任务结果
  getProofReviewResult: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0qsppg0w30sftvmu', 'get', config, vConfig),

  // 获取任务结果
  getProofReviewResultV3: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0qsppg0w40sftvmu', 'get', config, vConfig),

  // 获取审校生成资源文件url
  getProofReviewResultUrl: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0qsppg0gjmf0sftvmu0vsm', 'get', config, vConfig),

  //添加大样审校流程记录
  addActionsProofRecords: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0qsppg0sfdpset',
      'post',
      config,
      vConfig
    ),
  // 取消预签发
  postPageLayoutUnpresign: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0mbzpvu0voqsftjho',
      'post',
      config,
      vConfig
    ),
  // 进入(完成最后五分钟
  postPageLayoutPresign: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0mbzpvu0qsftjho',
      'post',
      config,
      vConfig
    ),
  // 大样透印
  getStrikeThrough: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0tusjlfUispvhi',
      'get',
      config,
      vConfig
    ),

  // 大样图片名称
  getFileName: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0gjmfObnf', 'get', config, vConfig),
  //栏目大样详情
  getFullPage: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0gvmmqbhf', 'get', config, vConfig),

  //栏目大样详情
  getFullPageQuery: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0gvmmqbhfRvfsz', 'get', config, vConfig),
  //大样签发检查提示
  getFullPageSignCheck: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0mbzpvu0tjhoDifdl', 'POST', config, {
      noHideLoading: true,
      ...vConfig
    }),
  //生成数字报
  postGeneratePaper: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0hfofsbufQbqfs',
      'POST',
      config,
      vConfig
    ),
  //生成数字报前查询报纸刊期是否存在
  postCheckPaperDateExist: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0difdlQbqfsEbufFyjtu',
      'POST',
      config,
      vConfig
    ),
  //大样保存语音批注
  postFullPageVoice: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhf0wpjdf', 'POST', config, vConfig),
  //大样获取语音批注
  getFullPageVoice: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhf0wpjdf', 'GET', config, vConfig),
  //大样删除语音批注
  deleteFullPageVoice: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhf0wpjdf', 'DELETE', config, vConfig),
  getArticlesActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0f60bdujpot0efubjmbdujpot', 'get', config),
  //大样保存大样校对后的信息
  postFullPageProofInfo: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0tbwfGvmmQbhfJogp', 'POST', config, {
      ...vConfig,
      isSimpleSecurity: true
    }),
  //大样获取最新的大样校对后的信息
  getFullPageProofInfo: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0hfuGvmmQbhfDifdlJogp',
      'GET',
      config,
      vConfig
    )
}
